export default __webpack_public_path__ + "static/media/KY.f6b09f63.svg";